import React from "react";

/**
 * Shown while a lazily-loaded route chunk is in flight.
 *
 * A skeleton sized to the content area rather than a centred spinner: routes are
 * code-split, so this appears on nearly every first navigation to a section, and a
 * spinner that replaces the whole page reads as "something went wrong" where a
 * skeleton reads as "loading".
 */
const RouteFallback = () => (
  <div className="animate-pulse p-2" role="status" aria-live="polite">
    <span className="sr-only">Loading…</span>
    <div className="mb-6 h-8 w-64 rounded-lg bg-slate-200" />
    <div className="mb-4 grid grid-cols-1 gap-4 sm:grid-cols-3">
      <div className="h-24 rounded-xl bg-slate-100" />
      <div className="h-24 rounded-xl bg-slate-100" />
      <div className="h-24 rounded-xl bg-slate-100" />
    </div>
    <div className="space-y-3">
      <div className="h-4 w-full rounded bg-slate-100" />
      <div className="h-4 w-5/6 rounded bg-slate-100" />
      <div className="h-4 w-4/6 rounded bg-slate-100" />
    </div>
  </div>
);

export default RouteFallback;
